import React from 'react';
import { motion as Motion } from 'framer-motion';

const Section = ({ children, className = '', id, dark = false, spacing = 'py-12 md:py-16 lg:py-32' }) => {
  return (
    <section
      id={id}
      className={`${spacing} ${dark ? 'bg-stone-50' : 'bg-white'} ${className}`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          {children}
        </Motion.div>
      </div>
    </section>
  );
};

export default Section;
